import React from 'react';
import styles from './TransportPage.module.scss';
import Transports from '../../modules/transports';

const TransportPage = () => {
  return (
    <div className={styles.root}>
      <Transports />
    </div>
  );
};

export default TransportPage;
